var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmolMoveDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13l5.173-5.173-1.179-1.178L10 10.643 6.006 6.649 4.827 7.827 10 13z",
    fill: "#DF2F2F"
  })));
}
export default __webpack_public_path__ + "static/svg/smol-move-down.svg";
export { SvgSmolMoveDown as ReactComponent };